import React from "react";
import { Dialog, DialogContent, DialogContentText, DialogTitle, IconButton, Typography } from "@material-ui/core";

import { Close } from "@material-ui/icons";

const styles = {
  closeButton: {
    position: "absolute",
    right: 8,
    top: 8,
  },
};

export default function DialogVersion(props) {
  const { state, onChange } = props;

  return (
    <Dialog open={state} onClose={() => onChange(false)} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle onClose={() => onChange(false)} id="alert-dialog-title">
        <Typography variant="h6" component="p">
          Version de Gescime non compatible
        </Typography>

        <IconButton aria-label="close" style={styles.closeButton} onClick={() => onChange(false)}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Votre version de Gescime ne vous permet pas d'utiliser l'application 'Gardiens des cimetières'
          <br />
          Veuillez mettre à jours votre logiciel Gescime
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}
